const stepFormSection = $('.form-section-parent');
const stepFormSlider = stepFormSection.find('.slider-nav-parent');
const stepFormParent = $('.hs-form-html');
const stepFormLineParent = stepFormSection.find('.step-form-line-parent');
const thankMessage = $('.hs-form-thanks-message');
let formSteps;
let prevListener = undefined;
let firstFromInteraction = true;
let sliderInTL;
let submitButton;
//let errorShowed = false;
const portalId = stepFormParent.attr('data-portal-id');
const formId = stepFormParent.attr('data-form-id');

const animateLastStep = ({ from, to, name }) => {
  const thankMessageTitle = thankMessage.find('.hs-form-thanks-message-title');
  const thankMessageText = thankMessage.find('.hs-form-thanks-message-text');
  thankMessageTitle.text(`Thanks, ${name.split(' ')[0]}!`);
  const prevStep = formSteps.eq(from);
  animatePrevStep(prevStep, to);
  animateNextStep(thankMessage, from, 1, false);
  animateLineIcons(1, from, to);
};

const sendForm = (from, to) => {
  sendFormAPI(stepFormParent, animateLastStep, { from: from, to: to });
};

const setLineIcons = () => {
  formSteps.each(function (index) {
    const stepInput = $(this).find('.hsfc-Row').find('input, textarea');
    let filedName;
    stepInput.each(function(){
      if($(this).attr('name') != undefined){
        filedName = $(this).attr('name');
      }
    })
    //const filedName = stepInput.attr('name')
    const iconParent = $('<div>', {
      class: 'step-form-line-icon-parent',
    });
    const iconElement = $('<img>', {
      class: 'step-form-line-icon',
      src: chooseIcon(filedName),
    });
    iconParent.append(iconElement);
    stepFormLineParent.append(iconParent);
    const position = Math.min(1, Math.max(0, 0.5 + index * 0.4));
    gsap.set(iconParent, {
      motionPath: {
        path: '#step-form-path',
        align: '#step-form-path',
        alignOrigin: [0.5, 0.5],
        start: position,
        end: position,
      },
      transformOrigin: '50% 50%',
    });
    if (index == 0) {
      gsap.set(iconParent, { scale: 1.5 });
    }
  });
  const iconParent = $('<div>', {
    class: 'step-form-line-icon-parent',
  });
  const iconElement = $('<img>', {
    class: 'step-form-line-icon',
    src: emojiIconsURLs['emoji-icon-success'],
  });
  iconParent.append(iconElement);
  stepFormLineParent.append(iconParent);
  gsap.set(iconParent, {
    motionPath: {
      path: '#step-form-path',
      align: '#step-form-path',
      alignOrigin: [0.5, 0.5],
      start: 1,
      end: 1,
    },
    transformOrigin: '50% 50%',
  });
};

const updateLineIconsPositions = () => {
  const path = document.querySelector('#step-form-path');
  if (!path) return;

  gsap.utils.toArray('.step-form-line-icon-parent').forEach((icon, index) => {
    const position = Math.min(1, Math.max(0, 0.5 + index * 0.4));

    gsap.set(icon, {
      motionPath: {
        path: path,
        align: path,
        alignOrigin: [0.5, 0.5],
        start: position,
        end: position,
      },
      transformOrigin: '50% 50%',
    });
  });
};

const animateLineIcons = (direction, from, to) => {
  $('.step-form-line-icon-parent').each(function (index) {
    const startPoint = direction == 1 ? 0.5 : 0.1;
    const endPoint = direction == 1 ? 0.1 : 0.5;
    const mult = direction == 1 ? from : to;
    const positionStart = Math.min(1, Math.max(0, startPoint + (index - mult) * 0.4));
    const positionEnd = Math.min(1, Math.max(0, endPoint + (index - mult) * 0.4));
    gsap.to($(this), {
      motionPath: {
        path: '#step-form-path',
        align: '#step-form-path',
        alignOrigin: [0.5, 0.5],
        start: positionStart,
        end: positionEnd,
      },
      duration: 1.57,
      ease: 'pageInEasing',
    });
    if (index == from) {
      gsap.to($(this), {
        scale: 1,
        duration: 1.57,
        ease: 'pageInEasing',
      });
    }
    if (index == to) {
      gsap.to($(this), {
        scale: 1.5,
        duration: 1.57,
        ease: 'pageInEasing',
      });
    }
  });
};

const errorAniamtion = (direction, currentStep, currentInput) => {
  const errorOffset = isDesktop() ? 1.5 : isTablet() ? 1.5 : 6.667;
  gsap.to(currentInput, {
    marginBottom: direction ? `${errorOffset}vw` : '0',
    duration: 0.67,
    ease: 'pageInEasing',
  });
  gsap.to(currentStep.find('.hsfc-ErrorAlert'), {
    opacity: direction ? 1 : 0,
    duration: 0.67,
    ease: 'opacityInEasing',
    delay: direction ? 0.2 : 0,
  });
  gsap.to(currentStep.find('.hsfc-ErrorAlert'), {
    y: direction ? 0 : `-${errorOffset}vw`,
    duration: 0.67,
    ease: 'pageInEasing',
  });
};

const showError = (index, direction, isValid) => {
  if (!isValid) {
    const currentStep = formSteps.eq(index);
    const currentRow = currentStep.find('.hsfc-Row');
    const currentInput = currentRow.find('input, textarea');
    if (direction) {
      currentInput.focus();
      currentInput.blur();
      const checkExist = setInterval(() => {
        if (currentStep.find('.hsfc-ErrorAlert').length) {
          errorAniamtion(direction, currentStep, currentInput);
          clearInterval(checkExist);
        }
      }, 100);
    } else {
      errorAniamtion(direction, currentStep, currentInput);
    }
  }
};

const checkIsBlocked = (from) => {
  const currentStep = formSteps.eq(from);
  const currentInput = currentStep.find('.hsfc-Row').find('input, textarea');
  const currentInvalid = currentInput.attr('aria-invalid') == 'true';
  const isRequired = currentInput.attr('aria-required') == 'true';

  if ((currentInvalid || currentInput.val() == '') && isRequired) {
    return true;
  }
  return false;
};

const addInputListener = (from, to) => {
  if (from) {
    const prevStep = formSteps.eq(from);
    const prevInput = prevStep.find('.hsfc-Row').find('input, textarea');
    prevInput.off('input change');
  }
  const currentStep = formSteps.eq(to);
  const currentInput = currentStep.find('.hsfc-Row').find('input, textarea');
  const isRequired = currentInput.attr('aria-required') == 'true';

  isValid = checkIsBlocked(to);
  currentInput.on('input change', function () {
    const currentInvalid = currentInput.attr('aria-invalid') == 'true';
    if ((isRequired || $(this).val() == '') && currentInvalid) {
      isValid = false;
      return;
    } else {
      showError(to, false, isValid);
      isValid = true;
    }
  });
};

const animatePrevStep = (prevStep, to) => {
  const stepsOffset = isDesktop() ? 63.8125 : isTablet() ? 100 : 100;
  gsap.to(prevStep, {
    x: `-${(isDesktop() ? 63.8125 : isTablet() ? 78.776 : 95.8335) * to}vw`,
    duration: 1.5,
    ease: 'pageInEasing',
  });
  gsap.fromTo(
    prevStep,
    {
      scale: 1,
    },
    {
      scale: 0.5,
      duration: 1.33,
      ease: 'pageInEasing',
    }
  );
  gsap.fromTo(
    prevStep,
    {
      opacity: 1,
    },
    {
      opacity: 0,
      duration: 1.17,
      ease: 'opacityInEasing',
    }
  );
};

const animateNextStep = (nextStep, from, to, isOnComplete = true) => {
  const stepsOffset = isDesktop() ? 63.8125 : isTablet() ? 100 : 100;
  gsap.to(nextStep, {
    x: `-${(isDesktop() ? 63.8125 : isTablet() ? 78.776 : 95.8335) * to}vw`,
    duration: 1.23,
    ease: 'pageInEasing',
    delay: 0.34,
    onComplete: () => {
      if (isOnComplete) {
        stepFormSlider.attr('data-is-blocked', 'none');
        addInputListener(from, to);
      }
    },
  });
  gsap.fromTo(
    nextStep,
    {
      scale: 0.5,
    },
    {
      scale: 1,
      duration: 1.07,
      ease: 'pageInEasing',
      delay: 0.5,
    }
  );
  gsap.fromTo(
    nextStep,
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.9,
      ease: 'opacityInEasing',
      delay: 0.67,
    }
  );
};

const setSteps = (formSteps) => {
  gsap.set(formSteps, {
    x: (index) => `${index * 100}vw`,
  });
};

const formSliderAnimation = (direction, from, to) => {
  const prevStep = formSteps.eq(from);
  const nextStep = formSteps.eq(to);
  const excludedSteps = prevStep.add(nextStep);

  animatePrevStep(prevStep, to);
  animateNextStep(nextStep, from, to);

  isDesktop() ? animateLineIcons(direction, from, to) : false;
};

const stepFormInTL = gsap.timeline({
  paused: true,
});

const stepFormLineInTL = gsap.timeline({
  paused: true,
});

const addFormLineIn = () => {
  const lineWrapper = stepFormLineParent.find('.step-form-line-wrapper');
  const lineIcons = stepFormLineParent.find('.step-form-line-icon-parent');

  stepFormLineInTL.add(
    gsap.to(lineWrapper, {
      x: '100%',
      duration: 1.67,
      ease: 'inEasing',
    }),
    0
  );
  stepFormLineInTL.add(
    gsap.fromTo(
      lineIcons,
      {
        scale: 0,
      },
      {
        scale: (index) => (index == 0 ? 1.5 : 1),
        duration: (index) => (index <= 2 ? 1 : 0),
        ease: 'pageInEasing',
        delay: (index) => (index <= 2 ? (index == 0 ? 0.1 : 0.5) : 0),
      }
    ),
    0
  );
};

const stepFormIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  stepFormInTL.add(
    animateSectionTopperIn({
      sectionParent: stepFormSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  stepFormInTL.add(elementInAnimationYWOpacity(stepFormParent, '16.25vw', 0, 1, 1, 0.67, 0.17).play(), 0.1);
};

const addFormStepAnimation = (
  slider,
  slidedObject,
  isNextBlockedCallback,
  objectAnimationCallback,
  errorCallback,
  finalCallback
) => {
  const navBtns = slider.find('.slider-nav-btn');
  const navSteps = addSliderSteps(slider, slidedObject);
  addSliderHover(slider);
  const min = 0;
  const max = slidedObject.length - 1;
  let currentStep = 0;
  navBtns.on('click', function () {
    const isBlocked = slider.attr('data-is-blocked');
    const isNextBlocked = isNextBlockedCallback(currentStep);
    if (isBlocked == 'both') {
      return;
    }
    if (isNextBlocked && $(this).hasClass('next')) {
      errorCallback(currentStep, true, false);
      return;
    }

    slider.attr('data-is-blocked', 'both');
    const direction = $(this).hasClass('next') ? 1 : -1;
    const to = currentStep + direction;

    if (to == min) {
      navBtns.filter('.prev').prop('disabled', true);
    } else if (to == max) {
    } else if (to - 1 == max) {
      finalCallback(currentStep, to);
    } else {
      navBtns.prop('disabled', false);
    }

    if (to <= max) {
      objectAnimationCallback(direction, currentStep, to);
      changeSliderStep(slider, slidedObject, currentStep, to);
    }
    currentStep = to;
  });
};

if (stepFormParent.length) {
  const observer = new MutationObserver(function (mutationsList, observer) {
    if (stepFormParent.find('form').length) {
      observer.disconnect();
      submitButton = stepFormParent.find('.hsfc-Button[type="submit"]');
      formSteps = stepFormParent.find('.hsfc-Step');
      addFormStepAnimation(stepFormSlider, formSteps, checkIsBlocked, formSliderAnimation, showError, sendForm);
      addSliderInAnimation(stepFormSlider, true, 50, true);
      setLineIcons();

      addInputListener(undefined, 0);

      formSteps.on('keydown', 'input, select, textarea', function (e) {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      });
    }
  });
  observer.observe(stepFormParent[0], { childList: true, subtree: true });
}

const initStepForm = () => {
  stepFormIn();
  addFormLineIn();
  ScrollTrigger.create({
    trigger: stepFormSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => {
      stepFormInTL.progress(self.progress);
    },
  });
  ScrollTrigger.create({
    trigger: stepFormSection,
    start: 'top top+=10%',
    end: 'bottom bottom',
    once: true,
    onUpdate: (self) => {
      stepFormLineInTL.progress(self.progress);
    },
  });
}

/*
$(window).on('heroReady', () => {
  initStepForm();
});
*/

$(window).on('resize', () => {
  updateLineIconsPositions();
});

addSectionObserver(stepFormSection, initStepForm, false);